import { render, staticRenderFns } from "./ApprovalEntries.vue?vue&type=template&id=0adee35a&scoped=true"
import script from "./ApprovalEntries.vue?vue&type=script&lang=js"
export * from "./ApprovalEntries.vue?vue&type=script&lang=js"
import style0 from "./ApprovalEntries.vue?vue&type=style&index=0&id=0adee35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adee35a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardTitle,VChip,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VTimeline,VTimelineItem})
